import { SVGProps } from "react";

const ChevronDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M3.2 5.6 8 10.4l4.8-4.8L14 6.8 8 12.8 2 6.8l1.2-1.2Z" />
    </svg>
  );
};

export default ChevronDown;
